export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Roman.cd7c5a73.woff";